import { render, staticRenderFns } from "./priceEchart.vue?vue&type=template&id=536175fb&scoped=true"
import script from "./priceEchart.vue?vue&type=script&lang=js"
export * from "./priceEchart.vue?vue&type=script&lang=js"
import style0 from "./priceEchart.vue?vue&type=style&index=0&id=536175fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536175fb",
  null
  
)

export default component.exports